import tw from 'twin.macro';

import { DoubleArrowToRight } from '@icons/DoubleArrowToRight';
import { useLayoutContext } from '@insights_module/context/LayoutContext';

const SidebarTogglerWrapper = tw.div`border-r border-solid border-gray-1 hidden sm:block`;
const SidebarToggler = tw.button`inline-block p-[4px] rounded-[4px] bg-gray-1 mr-[16px]`;

export const SidebarToggleButton = ({
  mode = 'close',
  className,
}: {
  mode?: 'open' | 'close';
  className?: string;
}) => {
  const { isSidebarVisible, setIsSidebarVisible } = useLayoutContext();

  if ((isSidebarVisible && mode === 'close') || (!isSidebarVisible && mode === 'open')) {
    return null;
  }

  return (
    <SidebarTogglerWrapper css={[mode === 'open' && tw`border-none`]}>
      <SidebarToggler
        onClick={() => setIsSidebarVisible(!isSidebarVisible)}
        css={[mode === 'open' && tw`!mx-0`]}
        className={className}>
        <DoubleArrowToRight
          tw='fill-text-and-icon w-[16px] h-[16px]'
          css={[mode === 'open' && tw`rotate-180`]}
        />
      </SidebarToggler>
    </SidebarTogglerWrapper>
  );
};
